import CourseStatus from '../../../api/CourseStatus';
import * as types from './mutation-types';

export const index = async ({commit}) => {
    const json = await new CourseStatus().index();

    commit(types.COURSE_STATUSES, json);
};

export default {
    index,
};



// WEBPACK FOOTER //
// ./src/store/modules/courseStatus/actions.js